import { BaseService } from "./baseService";

export interface MailingListSubscribeRequest {
  email: string;
  name?: string;
}

export interface MailingListSubscribeResponse {
  success: boolean;
  message: string;
  errors?: Array<{ field: string; message: string }>;
}

export class MailingListService extends BaseService {
  static async subscribe(data: MailingListSubscribeRequest): Promise<MailingListSubscribeResponse> {
    try {
      const res = await this.post("/mailing-list/subscribe", data);
      // Try to parse JSON body safely
      let body: any = null;
      try {
        const text = await res.text();
        body = text ? JSON.parse(text) : null;
      } catch (_) {
        body = null;
      }

      // Handle validation errors (400)
      if (res.status === 400) {
        if (body && Array.isArray(body.errors)) {
          return {
            success: false,
            message: body.message || "Please fix the errors and try again.",
            errors: body.errors,
          };
        }
        return { success: false, message: (body && (body.message || body.error)) || "Invalid request." };
      }

      // Non-OK generic error
      if (!res.ok) {
        return { success: false, message: "Subscription failed. Please try again later." };
      }

      // Normalize success shapes. Backend returns e.g. { status: "subscribed" | "already_subscribed", email }
      if (body && typeof body === 'object') {
        const status = body.status as string | undefined;
        if (status === 'subscribed') {
          return { success: true, message: "You're subscribed!" };
        }
        if (status === 'already_subscribed') {
          return { success: true, message: "You're already subscribed." };
        }

        // If backend already provides a success shape, coerce it
        if (typeof body.success === 'boolean') {
          return {
            success: !!body.success,
            message: body.message || (body.success ? "You're subscribed!" : "Subscription failed"),
            errors: Array.isArray(body.errors) ? body.errors : undefined,
          };
        }
      }

      // Fallback success when OK but unknown shape
      return { success: true, message: "You're subscribed!" };
    } catch (e) {
      console.error("Mailing list subscribe error", e);
      return { success: false, message: "Network error. Please try again." };
    }
  }
}
